import { Component } from '@angular/core';

@Component({
    selector: 'app-remove-data',
    templateUrl: './remove-data.component.html',
    styleUrls: ['./remove-data.component.scss'],
})
export class RemoveDataComponent {}
